import { ROUTES_NAME } from "../../../config/constants";
import {
  ADVANCE_SEARCH_ERROR,
  ADVANCE_SEARCH_REQUEST,
  ADVANCE_SEARCH_SUCCESS,
  DASHBOARD_ALL_ERROR,
  DASHBOARD_ALL_REQUEST,
  DASHBOARD_ALL_SUCCESS,
  FAILED_ERROR,
  FAILED_REQUEST,
  FAILED_SUCCESS,
  INVALID_GATEWAY_ERROR,
  INVALID_GATEWAY_REQUEST,
  INVALID_GATEWAY_SUCCESS,
  LINKED_PAYPAL_ERROR,
  LINKED_PAYPAL_REQUEST,
  LINKED_PAYPAL_SUCCESS,
  MISSING_ERROR,
  MISSING_REQUEST,
  MISSING_SUCCESS,
  NETWORTH_ERROR,
  NETWORTH_REQUEST,
  NETWORTH_SUCCESS,
  PENDING_ERROR,
  PENDING_REQUEST,
  PENDING_SUCCESS,
  QUEUED_ERROR,
  QUEUED_REQUEST,
  QUEUED_SUCCESS,
  RECEIVED_LAST_TEN_DAYS_ERROR,
  RECEIVED_LAST_TEN_DAYS_REQUEST,
  RECEIVED_LAST_TEN_DAYS_SUCCESS,
  SYNCED_ERROR,
  SYNCED_LAST_TEN_DAYS_ERROR,
  SYNCED_LAST_TEN_DAYS_REQUEST,
  SYNCED_LAST_TEN_DAYS_SUCCESS,
  SYNCED_REQUEST,
  SYNCED_SUCCESS,
} from "./ActionType";
import { ACCESS_TOKEN } from "../../../constants";

let storeDashboardRequestSequence = 0;

const normalizeShopId = (shopId) => String(shopId ?? "").trim();

const requestMeta = (operation, shopId) => ({
  operation,
  shopId: normalizeShopId(shopId),
  requestId: `${operation}:${Date.now()}:${++storeDashboardRequestSequence}`,
});

export const getNetworth = (shopId) => {
  return async (dispatch) => {
    await dispatch(networthRequest());
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.networth(
      shopId
    )}`;

    fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((newtworth) => {
        dispatch(networthSuccess(newtworth));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(networthError());
      });
  };
};

function networthRequest(newtworthData) {
  return {
    type: NETWORTH_REQUEST,
    payload: newtworthData,
  };
}

function networthSuccess(newtworthData) {
  return {
    type: NETWORTH_SUCCESS,
    payload: newtworthData,
  };
}

function networthError(newtworthData) {
  return {
    type: NETWORTH_ERROR,
    payload: newtworthData,
  };
}

//for synced data

export const getSyncedData = (shopId) => {
  return async (dispatch) => {
    const meta = requestMeta("synced", shopId);
    dispatch(syncedRequest(meta));
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.synced(shopId)}`;
    fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((synced) => {
        dispatch(syncedSuccess(synced, meta));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(syncedError(undefined, meta));
      });
  };
};

function syncedRequest(meta) {
  return {
    type: SYNCED_REQUEST,
    meta,
  };
}

function syncedSuccess(syncedData, meta) {
  return {
    type: SYNCED_SUCCESS,
    payload: syncedData,
    meta,
  };
}

function syncedError(syncedData, meta) {
  return {
    type: SYNCED_ERROR,
    payload: syncedData,
    meta,
  };
}

//LAST TEN DAYS SYNCED

export const getSyncedLastTenDays = (shopId) => {
  return async (dispatch) => {
    dispatch(syncedLastTenDaysRequest());
    const url = `${
      process.env.REACT_APP_BACKEND_API_URL
    }${ROUTES_NAME.synced_last_ten_days(shopId)}`;

    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        dispatch(syncedLastTenDaysSuccess(data));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(syncedLastTenDaysError());
      });
  };
};

function syncedLastTenDaysRequest(syncedData) {
  return {
    type: SYNCED_LAST_TEN_DAYS_REQUEST,
    payload: syncedData,
  };
}

function syncedLastTenDaysSuccess(syncedData) {
  return {
    type: SYNCED_LAST_TEN_DAYS_SUCCESS,
    payload: syncedData,
  };
}

function syncedLastTenDaysError(syncedData) {
  return {
    type: SYNCED_LAST_TEN_DAYS_ERROR,
    payload: syncedData,
  };
}

//RECEIVED LAST TEN DAYS

export const receivedLastTenDaysRequestData = (shopId) => {
  return async (dispatch) => {
    dispatch(receivedLastTenDaysRequest());
    const url = `${
      process.env.REACT_APP_BACKEND_API_URL
    }${ROUTES_NAME.received_last_ten_days(shopId)}`;

    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((received) => {
        dispatch(receivedLastTenDaysSuccess(received));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(receivedLastTenDaysError());
      });
  };
};

function receivedLastTenDaysRequest(receivedData) {
  return {
    type: RECEIVED_LAST_TEN_DAYS_REQUEST,
    payload: receivedData,
  };
}

function receivedLastTenDaysSuccess(receivedData) {
  return {
    type: RECEIVED_LAST_TEN_DAYS_SUCCESS,
    payload: receivedData,
  };
}

function receivedLastTenDaysError(receivedData) {
  return {
    type: RECEIVED_LAST_TEN_DAYS_ERROR,
    payload: receivedData,
  };
}

//LINKED PAYPAL ACCOUNT

export const getLinkedPaypalShop = (shopId) => {
  return async (dispatch) => {
    dispatch(linkedPaypalByShopRequest());
    const url = `${
      process.env.REACT_APP_BACKEND_API_URL
    }${ROUTES_NAME.linked_paypal_by_shop(shopId)}`;

    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((paypal) => {
        dispatch(linkedPaypalByShopSuccess(paypal));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(linkedPaypalByShopError());
      });
  };
};

function linkedPaypalByShopRequest(receivedData) {
  return {
    type: LINKED_PAYPAL_REQUEST,
    payload: receivedData,
  };
}

function linkedPaypalByShopSuccess(receivedData) {
  return {
    type: LINKED_PAYPAL_SUCCESS,
    payload: receivedData,
  };
}

function linkedPaypalByShopError(receivedData) {
  return {
    type: LINKED_PAYPAL_ERROR,
    payload: receivedData,
  };
}

// DASHBOARD-ALL API-CALL

export const getDashboardAllData = (shopId) => {
  return async (dispatch) => {
    const meta = requestMeta("dashboardAll", shopId);
    dispatch(dashboardAllRequest(meta));
    const url = `${
      process.env.REACT_APP_BACKEND_API_URL
    }${ROUTES_NAME.dashboard_all(shopId)}`;

    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        dispatch(dashboardAllSuccess(data, meta));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(dashboardAllError(undefined, meta));
      });
  };
};

function dashboardAllRequest(meta) {
  return {
    type: DASHBOARD_ALL_REQUEST,
    meta,
  };
}

function dashboardAllSuccess(receivedData, meta) {
  return {
    type: DASHBOARD_ALL_SUCCESS,
    payload: receivedData,
    meta,
  };
}

function dashboardAllError(receivedData, meta) {
  return {
    type: DASHBOARD_ALL_ERROR,
    payload: receivedData,
    meta,
  };
}

//FAILED API CALL

export const getFailedData = (shopId) => {
  return async (dispatch) => {
    const meta = requestMeta("failed", shopId);
    dispatch(failedRequest(meta));
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.failed(shopId)}`;

    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        dispatch(failedSuccess(data, meta));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(failedError(undefined, meta));
      });
  };
};

function failedRequest(meta) {
  return {
    type: FAILED_REQUEST,
    meta,
  };
}

function failedSuccess(receivedData, meta) {
  return {
    type: FAILED_SUCCESS,
    payload: receivedData,
    meta,
  };
}

function failedError(receivedData, meta) {
  return {
    type: FAILED_ERROR,
    payload: receivedData,
    meta,
  };
}

//mISSING API CALL

export const getMissingData = (shopId) => {
  return async (dispatch) => {
    const meta = requestMeta("missing", shopId);
    dispatch(missingRequest(meta));
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.missing(shopId)}`;
    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        dispatch(missingSuccess(data, meta));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(missingError(undefined, meta));
      });
  };
};

function missingRequest(meta) {
  return {
    type: MISSING_REQUEST,
    meta,
  };
}

function missingSuccess(receivedData, meta) {
  return {
    type: MISSING_SUCCESS,
    payload: receivedData,
    meta,
  };
}

function missingError(receivedData, meta) {
  return {
    type: MISSING_ERROR,
    payload: receivedData,
    meta,
  };
}

// queued API CALL

export const getQueuedData = (shopId) => {
  return async (dispatch) => {
    dispatch(queuedRequest());
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.queued(shopId)}`;

    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        dispatch(queuedSuccess(data));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(queuedError());
      });
  };
};

function queuedRequest(receivedData) {
  return {
    type: QUEUED_REQUEST,
    payload: receivedData,
  };
}

function queuedSuccess(receivedData) {
  return {
    type: QUEUED_SUCCESS,
    payload: receivedData,
  };
}

function queuedError(receivedData) {
  return {
    type: QUEUED_ERROR,
    payload: receivedData,
  };
}

// PENDIND API CALL

export const getPendingData = (shopId) => {
  return async (dispatch) => {
    const meta = requestMeta("pending", shopId);
    dispatch(pendingRequest(meta));
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.pending(
      shopId
    )}`;

    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        dispatch(pendingSuccess(data, meta));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(pendingError(undefined, meta));
      });
  };
};

function pendingRequest(meta) {
  return {
    type: PENDING_REQUEST,
    meta,
  };
}

function pendingSuccess(receivedData, meta) {
  return {
    type: PENDING_SUCCESS,
    payload: receivedData,
    meta,
  };
}

function pendingError(receivedData, meta) {
  return {
    type: PENDING_ERROR,
    payload: receivedData,
    meta,
  };
}

// Advance Search API call for the dashboard and orders table

export const getAdvanceSearchData = (payload) => {
  const { page, ordersStatus, startDate, endDate, search, shopId } = payload;
  const normalizeOrderDateTime = (value, endOfDay = false) => {
    if (!value) {
      return null;
    }
    if (typeof value === "string" && value.includes(" ")) {
      return value;
    }
    const base = typeof value === "string" ? value.split("T")[0] : value;
    return `${base} ${endOfDay ? "23:59:59" : "00:00:00"}`;
  };
  return async (dispatch) => {
    const meta = requestMeta("advanceSearch", shopId);
    dispatch(advanceSearchRequest(meta));
    const url = `${
      process.env.REACT_APP_BACKEND_API_URL
    }${ROUTES_NAME.advanceSearch(shopId)}`;
    const controller = new AbortController();
    let timeoutId = null;
    let timedOut = false;

    try {
      const fetchRequest = fetch(url, {
        method: "POST",
        credentials: "include",
        signal: controller.signal,
        body: JSON.stringify({
          pageNumber: page,
          length: 10,
          itemCriteria: {
            orderStatus: ordersStatus,
            startDate: normalizeOrderDateTime(startDate, false),
            endDate: normalizeOrderDateTime(endDate, true),
            search: search,
          },
        }),
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
          "Content-Type": "application/json",
          Origin: `${process.env.REACT_APP_URL}`,
        },
      });
      const timeout = new Promise((_, reject) => {
        timeoutId = window.setTimeout(() => {
          timedOut = true;
          controller.abort();
          reject(new Error("Orders request timed out after 10 seconds."));
        }, 10_000);
      });
      const response = await Promise.race([fetchRequest, timeout]);
      let data = null;
      try {
        data = await response.json();
      } catch (_error) {
        data = null;
      }
      if (!response.ok) {
        const error = new Error(
          data?.message || `Orders request failed (${response.status})`
        );
        error.status = response.status;
        throw error;
      }
      dispatch(advanceSearchSuccess(data, meta));
      return { ok: true, data };
    } catch (error) {
      const failure = {
        message: timedOut
          ? "Orders request timed out after 10 seconds."
          : error?.message || "Orders are temporarily unavailable.",
        status: error?.status || null,
        authenticationError: error?.status === 401,
      };
      dispatch(advanceSearchError(failure, meta));
      return { ok: false, error: failure.message };
    } finally {
      if (timeoutId !== null) window.clearTimeout(timeoutId);
    }
  };
};

function advanceSearchRequest(meta) {
  return {
    type: ADVANCE_SEARCH_REQUEST,
    meta,
  };
}

function advanceSearchSuccess(receivedData, meta) {
  return {
    type: ADVANCE_SEARCH_SUCCESS,
    payload: receivedData,
    meta,
  };
}

function advanceSearchError(receivedData, meta) {
  return {
    type: ADVANCE_SEARCH_ERROR,
    payload: receivedData,
    meta,
  };
}

//INVALID GATEWAY API CALL

export const invalidGatewayData = (shopId) => {
  return async (dispatch) => {
    dispatch(invalidRequest());
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.invalid_gateway(shopId)}`;
    await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
        Origin: `${process.env.REACT_APP_URL}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        dispatch(invalidSuccess(data));
      })
      .catch((data) => {
        console.log(data, "error");
        dispatch(invalidError());
      });
  };
};

function invalidRequest(receivedData) {
  return {
    type: INVALID_GATEWAY_REQUEST,
    payload: receivedData,
  };
}

function invalidSuccess(receivedData) {
  return {
    type: INVALID_GATEWAY_SUCCESS,
    payload: receivedData,
  };
}

function invalidError(receivedData) {
  return {
    type: INVALID_GATEWAY_ERROR,
    payload: receivedData,
  };
}
